import { Component, Input, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { AppConfig } from '@project_app/config/app.config';
import { Router } from '@angular/router';
import { environment } from '@environment';
import { CategoryFilterPipe } from '@shared/pipes/category-filter.pipe';
import { DeferImageLoadDirective } from '../../../../shared/directives/defer-image-load.directive';

@Component({
    selector: 'app-mobile-shop-by-category',
    templateUrl: './mobile-shop-by-category.component.html',
    styleUrls: ['./mobile-shop-by-category.component.scss'],
    standalone: true,
    imports: [DeferImageLoadDirective, CategoryFilterPipe]
})

export class MobileShopByCategoryComponent implements OnChanges {

    @Input() memberships: any;
    @Output() showMenu = new EventEmitter();
    loadingCategories: Array<any> = [...new Array(8).keys()];
    isLoading: boolean = true;
    primaryBrandCategories: Array<any>;
    isThreeTileLayout: boolean = true;
    isBrandRating: boolean = false;
    brandId: number;

    constructor(
        private cdr: ChangeDetectorRef,
        private router: Router,
    ) {
        this.isBrandRating = AppConfig.isBrandRating;
        this.brandId = environment.brand.id;
    }

    ngOnChanges(change: SimpleChanges) {
        if (change.memberships.currentValue.length) {

            this.primaryBrandCategories = this.memberships[0].category;
            const categoryLayout = this.memberships[0].category_layout;
            if (categoryLayout) {
                this.isThreeTileLayout = (categoryLayout === '3-tile-layout');
            }

            this.isLoading = false;
            this.cdr.detectChanges();
        }
    }

    showMenuClick(category) {
        if (category.is_subscribable) {
            this.router.navigateByUrl('/membership');
        } else {
            this.showMenu.emit(category);
            this.cdr.detectChanges();
        }
    }
}
